/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonGroup, ButtonVariant, Collapse, Icon, Popover, Position, Size, Tag } from "@blueprintjs/core"
import { Fragment, useEffect, useState } from "react"
import { ID, POST_STATUS, SORT_TYPE, SortTypeData } from "src/libs/interfaces/layouts"
import { __, __cases, getContrastColor, isArraysJoint } from "src/libs/utilities"
import { ILanding, ILandingCategory, ILink, LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { isRole } from "src/settings/zustand/user"
import { getChildrenCats } from "../getCatsWithChildren"
import CategoriesEditForm from "./CategoriesEditForm"
import CategoriesTree from "./CategoriesTree"

 
import { Hint } from "src/libs/useful"
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { LINK_POST_TYPES } from "../../landing/primitive/LinksFeedPrimitive"

export interface ICategorySwitcherProps {
    status: POST_STATUS
    primitive: LinksFeedContent
    onCategories: (categories: ID[]) => void
    onStatus : (status: POST_STATUS) => void
    onDistination: (dist: "UP" | "DOWN") => void
    onSortTypes: ( _sorts: SORT_TYPE[] ) => void
    categories: ID[]
    items: ILink[]
    distination: "UP" | "DOWN"
    sorts: SORT_TYPE[]
    fullCount?: number
}

const CategorySwitcher = ( props: ICategorySwitcherProps ): JSX.Element => {
    const { status, onCategories, onStatus, categories, items, primitive  } = props
    const currentLanding: ILanding  = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const isLocal: boolean          = useLandingStore( (state: ILandingStore) => state.isLocal )
    const [allCategories, setAllCategories]= useState<ILandingCategory[]>([])
    const cats:ILandingCategory[]   = allCategories?.filter( c => !c.parentId ) || [] 
    const [isCatOpen, setIsCatOpen] = useState<boolean>( false )

    useEffect(() => {
         if( isLocal ) {
            setAllCategories( currentLanding.categories || [] )
         }
         else {
            actions( GET_FEED_ACTION, { data_type: "PELandingCategory", count: 10000 } ) //PELandingCategory
                .then(res => {
                    const cats = res.feed.map((f: any) => ({
                        ...f, 
                        id:f.slug 
                    }))
                    useLandingStore.setState({
                        currentLanding: {
                            ...currentLanding,
                            categories: cats
                        }
                    })
                    setAllCategories( cats )
                })
         }
    }, [ isLocal ])

    const onClick = (cat: ILandingCategory) => {
        const newCats: ID[] = !!categories.find(( id: ID ) => id === cat.id )
            ?
            categories.filter( ( id: ID ) => { 
               return ![ cat.id, ...getChildrenCats( cat.id, allCategories ) ].includes( id ) 
            })
            :
            [ 
                ...( categories ), 
                ...[ cat.id, ...getChildrenCats( cat.id, allCategories ) ]
            ]
        onCategories( newCats ) // !!newCats.length ? newCats : (allCategories).map( c => c.id ) ) 
    }
    const onClear = () => {
        onCategories( allCategories?.map(c => c.id) || [] )
    } 
    const onIsBack = () => { 
        props.onDistination( props.distination === "DOWN"  ? "UP" : "DOWN" )
    }
    const onSort = (key: SORT_TYPE) => {
        props.onSortTypes( [ key ] ) 
    }
    return !!items.filter((item: any) => (item.status === POST_STATUS.DRAFT)) 
        ?
        <div>
            <div className="d-flex align-items-center flex-wrap my-2 w-100" data-select-type="ignore">
                {
                    primitive?.isCategoryFiltered && <>
                        {
                            cats.map( cat => {
                                const is        = !!categories.find( ( id: ID ) => id === cat.id )
                                const half      = getChildrenCats( cat.id, allCategories )
                                const isHalf    = isArraysJoint( half.map(h => h.toString()), categories.map(h => h.toString()) )
                                const children = allCategories?.filter(c => c.parentId === cat.id) || []
                                return <Tag 
                                    style={{ 
                                        backgroundColor: is 
                                            ? 
                                            cat.color 
                                            : 
                                            isHalf 
                                                ? 
                                                "#FFFFFF66" 
                                                :
                                                "transparent", 
                                        border: `1px solid ${ cat.color }`,
                                        cursor : is ? undefined : "pointer"
                                    }} 
                                    className="d-flex  mr-1 mb-1 p-0"
                                    key={ cat.id } 
                                >
                                    <span className="d-flex align-items-center position-relative">
                                        <span 
                                            className="smallest letter-spacing-2 px-2 py-0" 
                                            style={{ 
                                                color: is 
                                                    ? 
                                                    getContrastColor( cat.color ) 
                                                    : 
                                                    cat.color 
                                            }} 
                                            onClick={ () => onClick(cat) }
                                        >
                                            { cat.title }
                                        </span>
                                        {
                                            !!children.length &&
                                            <Popover
                                                interactionKind="hover"
                                                position={ Position.BOTTOM }
                                                content={
                                                    <div className="p-0">
                                                        <div className="d-flex flex-column align-items-between">
                                                            <CategoriesTree 
                                                                cats={children}
                                                                categories={categories} 
                                                                onClick={onClick}
                                                            /> 
                                                        </div>
                                                    </div>
                                                }                                                    
                                                modifiers={{
                                                    arrow: { enabled: false },
                                                    flip: { enabled: true },
                                                    preventOverflow: { enabled: false },
                                                    offset: {
                                                        enabled: true,
                                                        options: {
                                                            offset: [0, 5],
                                                        },
                                                    },
                                                }}
                                            >
                                                <div className="px-2 d-flex align-items-center pointer">
                                                    <Icon icon="caret-down" size={11} color={ is ? getContrastColor( cat.color ) : cat.color } />
                                                </div>
                                            </Popover>
                                        }
                                        {
                                            isHalf && <div className="is-half-checker" style={{ backgroundColor: cat.color }} />
                                        }
                                    </span>
                                </Tag>
                            })
                        }
                        <Button variant={ButtonVariant.MINIMAL} size={Size.SMALL} icon="cross" onClick={onClear} />
                        {
                            isRole("administrator") &&
                            <CategoriesEditForm />
                        }
                    </>
                }
                {
                    primitive?.isOrder && <>
                        <Hint label={__(props.distination === "DOWN" ? "by straight" : "by reverse" )} >
                            <Button
                                variant={ ButtonVariant.MINIMAL }
                                icon={ props.distination === "DOWN" ? "sort-asc" : "sort-desc" }
                                className="mr-3"
                                onClick={ onIsBack } 
                            />
                        </Hint>

                        <ButtonGroup vertical={false} className="p-0">
                            {
                                Object.values( SORT_TYPE ).map( (key: SORT_TYPE) => {
                                    return <Hint  key={ key } label={ __( SortTypeData[key].label ) } >
                                        <Button  
                                            variant={ ButtonVariant.MINIMAL } 
                                            alignText="left"
                                            className={ props.sorts.includes( key ) ? `` : `opacity_5`}
                                            onClick={ () => onSort( key ) }  
                                        >
                                            <div className={`d-flex align-items-center ${ props.sorts.includes( key ) ? `` : `opacity_5`}`}>
                                                <img src={ SortTypeData[key].icon } height={14} alt="" />
                                            </div>  
                                        </Button>
                                    </Hint>
                                })
                            }
                        </ButtonGroup>
                    </>
                }

                <div className="d-flex align-items-center small letter-spacing-2 mr-3 ml-auto">
                    { props.fullCount } { __cases( props.fullCount , "items" ) }
                </div>
                {
                    primitive?.isStatusFiltered && <div className="">
                        <ButtonGroup>
                        {
                            LINK_POST_TYPES.map( pt => <Hint label={ __( pt.title ) } key={ pt._id }>
                                <Button 
                                    icon={ pt.icon } 
                                    variant={ ButtonVariant.MINIMAL } 
                                    className={ status === pt._id ? `` : `opacity_5` }
                                    onClick={ () => onStatus( pt._id ) }  
                                />
                            </Hint> )
                        } 
                        </ButtonGroup>
                    </div>
                }
            </div> 
            {
                !!categories.length && primitive?.isCategoryFiltered &&
                <div className="small mb-3 mx-2">
                    <div className="d-flex w-100 flex-wrap align-items-center">                        
                        {
                            categories.length < 5
                                ?
                                categories.map(id => {
                                    const category = allCategories?.find(c => c.id === id)
                                    if(!category) {
                                        return <Fragment key={ id } />
                                    }
                                    return <CategoryLabel category={ category } key={ id } />
                                })
                                : 
                                <>
                                    <Collapse isOpen={ isCatOpen } className="w-100">
                                        <div className="flex-wrap d-flex align-items-center w-100"> 
                                            {
                                                categories
                                                    .map( id => {
                                                        const category = allCategories?.find(c => c.id === id)
                                                        if(!category) {
                                                            return <Fragment key={ id } />
                                                        }
                                                        return <CategoryLabel category={ category } key={ id } />
                                                    })
                                            } 
                                            <Button variant={ ButtonVariant.MINIMAL } size={ Size.SMALL } onClick={ ()=> setIsCatOpen( false ) } className="ml-auto">
                                                <div className="smaller letter-spacing-2 opacity_75">
                                                    { __( "Close" ) }
                                                </div>
                                            </Button>
                                        </div>
                                    </Collapse> 
                                    <Collapse isOpen={ !isCatOpen } className="w-100">
                                        <div className="flex-wrap d-flex align-items-center w-100"> 
                                            {                                        
                                                categories
                                                    .filter((__, i) => i < 5)
                                                    .map(id => {
                                                        const category = allCategories?.find(c => c.id === id)
                                                        if(!category) {
                                                            return <Fragment key={ id } />
                                                        }
                                                        return <CategoryLabel category={ category } key={ id } />
                                                    })
                                            } 
                                            <Button variant={ ButtonVariant.MINIMAL } size={ Size.SMALL } onClick={ ()=> setIsCatOpen( true ) } className="ml-auto">
                                                <div className="smaller letter-spacing-2 opacity_75">
                                                    { __( "All" ) } { categories.length } { __cases( categories.length, "categories" ) }
                                                </div>
                                            </Button>
                                        </div>
                                    </Collapse>
                                </> 
                        }
                    </div> 
                </div>
            }
        </div>
        :
        <></>
}

export default CategorySwitcher


export interface ICategoryLabelProps {
    category: ILandingCategory
}
export const CategoryLabel = (props: any) : JSX.Element => {
    const { category } = props
    return !!category.content
            ?
            <Popover
                position={Position.RIGHT_TOP}
                interactionKind="hover"
                hoverOpenDelay={ 500 }
                content={
                    <div className="width-300 overflow-y-auto">
                        <div className="p-4">
                            { category.content }
                        </div>
                    </div>
                }
            >
                <div className="mx-2 border-bottom-dashed pointer" dangerouslySetInnerHTML={{__html: category.title }}/>
            </Popover>
            :
            <div className="mx-2" dangerouslySetInnerHTML={{__html: category.title }}/>
}